module.exports = __webpack_public_path__ + "static/media/AISuggestion.37a615b6.svg";